import { HttpClient } from '@/shared/lib/http-client';

export const fetchAutoNumberPatterns = async () => {
  const response = await HttpClient.get('/auto-number-patterns');

  return response.data;
};
